/* eslint-disable no-console */
export default class Logger {
  constructor (name, level) {
    this.name = typeof name !== 'undefined' ? name : ''
    this.level = typeof level !== 'undefined' ? level : 'NONE'
  }

  debug (title, msg) {
    if (typeof msg === 'undefined') {
      msg = title
      title = ''
    }
    if (this.level !== 'NONE') {
      if (this.name || title) {
        console.debug(((title ? `${title}` : '') + (this.name ? `[${this.name}]` : '')), msg)
      } else {
        console.debug(msg)
      }
    }
  }

  error (title, msg) {
    if (typeof msg === 'undefined') {
      msg = title
      title = ''
    }
    if (this.level !== 'NONE') {
      if (this.name || title) {
        console.error(((title ? `${title}` : '') + (this.name ? `[${this.name}]` : '')), msg)
      } else {
        console.error(msg)
      }
    }
  }

  info (title, msg) {
    if (typeof msg === 'undefined') {
      msg = title
      title = ''
    }
    if (this.level !== 'NONE') {
      if (this.name || title) {
        console.info(((title ? `${title}` : '') + (this.name ? `[${this.name}]` : '')), msg)
      } else {
        console.info(msg)
      }
    }
  }

  warn (title, msg) {
    if (typeof msg === 'undefined') {
      msg = title
      title = ''
    }
    if (this.level !== 'NONE') {
      if (this.name || title) {
        console.warn(((title ? `${title}` : '') + (this.name ? `[${this.name}]` : '')), msg)
      } else {
        console.warn(msg)
      }
    }
  }
}
